export const badEmailCharacters = '<>*()[]“?\\;:,';
